import React from "react";
import { useNavigate } from "react-router-dom";

const LoginPromptPopup = ({ message, onClose }) => {
  const navigate = useNavigate();

  return (
    <div className="fixed inset-0 flex items-center justify-center z-50 bg-black backdrop-blur-sm">
      <div className="bg-tertiary p-6 rounded-lg shadow-lg max-w-sm w-full text-center">
        <p className="text-hcolor font-outfit text-lg mb-4">{message}</p>
        <div className="flex justify-center gap-4">
          <button
            onClick={() => {
              onClose();
              navigate("/login");
            }}
            className="px-4 py-2 bg-hcolor text-tertiary rounded hover:bg-tertiary hover:text-hcolor border-2 border-hcolor transition-all duration-300"
          >
            Log In
          </button>
          <button
            onClick={onClose}
            className="px-4 py-2 border-2 border-hcolor text-hcolor rounded hover:bg-hcolor hover:text-tertiary transition-all duration-300"
          >
            Cancel
          </button>
        </div>
      </div>
    </div>
  );
};

export default LoginPromptPopup;